/**
 * Shared terminal theme and configuration.
 *
 * Both LocalTerminalView and TerminalView consume these constants
 * so the look stays perfectly in sync.
 */
import type { ITheme } from "@xterm/xterm";

export const TERMINAL_BG = "#0c0c0f";

export const terminalTheme: ITheme = {
  background: TERMINAL_BG,
  foreground: "#e4e4e7",
  cursor: "#a78bfa",
  cursorAccent: TERMINAL_BG,
  selectionBackground: "rgba(124, 58, 237, 0.25)",
  selectionForeground: "#fafafa",
  black: "#18181b",
  red: "#f87171",
  green: "#4ade80",
  yellow: "#facc15",
  blue: "#60a5fa",
  magenta: "#c084fc",
  cyan: "#22d3ee",
  white: "#e4e4e7",
  brightBlack: "#52525b",
  brightRed: "#fca5a5",
  brightGreen: "#86efac",
  brightYellow: "#fde047",
  brightBlue: "#93c5fd",
  brightMagenta: "#d8b4fe",
  brightCyan: "#67e8f9",
  brightWhite: "#fafafa",
};

export const terminalConfig = {
  fontFamily: '"JetBrains Mono", "Fira Code", Menlo, monospace',
  fontSize: 13,
  lineHeight: 1.3,
  fontWeight: "400" as const,
  fontWeightBold: "700" as const,
  letterSpacing: 0,
  cursorBlink: true,
  cursorStyle: "block" as const,
  cursorInactiveStyle: "outline" as const,
  scrollback: 10000,
  drawBoldTextInBrightColors: false,
  minimumContrastRatio: 1,

  // macOS: treat Option key as Meta so Alt+B / Alt+F etc. work as expected
  // in shells and TUI tools.
  macOptionIsMeta: true,
  macOptionClickForcesSelection: true,
};
